import { createSlice } from "@reduxjs/toolkit";
import { setChat } from "./setChatIDSlice";
import { makeChatId } from "../../utils/utils";
const resetChatState = (state) => {
    var _a;
    const isMobile = /Mobi|Android|iPhone/i.test(window.navigator.userAgent);
    if ((_a = state.selectedMessages) === null || _a === void 0 ? void 0 : _a.length)
        state.selectedMessages = [];
    if (state.showCheckbox)
        state.showCheckbox = false;
    if (state.isFavorites)
        state.isFavorites = false;
    if (isMobile)
        state.emojiIsOpen = false;
    if (state.selectedChannel)
        state.selectedChannel = null;
    if (state.isSearchMessage)
        state.isSearchMessage = false;
    state.onlineStatusSelectedUser = null;
    // state.menu.menuChild = ''
    // state.menu.bar = false
    // state.menu.cover = false
};
const initialState = {
    menu: {
        cover: false,
        bar: false,
        menuChild: ''
    },
    selectedChat: null,
    selectedMessages: [],
    changeMessage: null,
    isSendMessage: false,
    showCheckbox: false,
    currentUser: null,
    blackList: [],
    contacts: [],
    chatsList: [],
    loadChat: false,
    moreMessages: false,
    emojiIsOpen: false,
    selectedEmoji: '',
    isSearchMessage: false,
    replyToMessage: null,
    isFavorites: false,
    selectedChannel: null,
    clearGlobalSearchUser: false,
    onlineStatusSelectedUser: null,
    tempChat: null,
    isAtBottomScroll: false,
    targetMessages: []
};
export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        openMenu(state) {
            state.menu.cover = !state.menu.cover;
            state.menu.bar = !state.menu.bar;
        },
        closeMenu(state) {
            var _a;
            state.menu.bar = false;
            state.menu.cover = false;
            state.menu.menuChild = '';
            if ((_a = state.selectedMessages) === null || _a === void 0 ? void 0 : _a.length)
                state.selectedMessages = [];
        },
        closeBar(state, action) {
            state.menu.bar = false;
            state.menu.menuChild = action.payload;
            if (!state.menu.cover)
                state.menu.cover = true;
        },
        addSelectedMessage(state, action) {
            var _a;
            if ((_a = state.selectedMessages) === null || _a === void 0 ? void 0 : _a.some(item => item.messageID === action.payload.messageID))
                return; //изменил
            state.selectedMessages.push(action.payload);
        },
        clearSelectedMessage(state) {
            state.selectedMessages = [];
            state.isSendMessage = false,
                state.showCheckbox = false;
        },
        deleteSelectedMessage(state, action) {
            state.selectedMessages = state.selectedMessages.filter(message => message.messageID !== action.payload.messageID);
        },
        changeMessage(state, action) {
            state.changeMessage = action.payload;
            if (!action.payload)
                state.replyToMessage = null;
            if (state.replyToMessage)
                state.replyToMessage = null;
        },
        setReplyToMessage(state, action) {
            state.replyToMessage = action.payload;
            if (state.changeMessage)
                state.changeMessage = null;
        },
        isSendMessage(state, action) {
            state.isSendMessage = action.payload;
        },
        setShowCheckbox(state, action) {
            state.showCheckbox = action.payload;
        },
        setUser(state, action) {
            state.currentUser = action.payload;
            if (!action.payload) {
                state.selectedChat = null;
                state.menu = { cover: false, bar: false, menuChild: '' };
                state.isSendMessage = null;
                state.changeMessage = null;
                state.showCheckbox = false;
                state.selectedMessages = null;
                state.blackList = [];
                state.chatsList = [];
                state.contacts = [];
            }
        },
        setUserData(state, action) {
            state.currentUser.displayName = action.payload.displayName;
            state.currentUser.photoURL = action.payload.photoURL || '';
        },
        setChatList(state, action) {
            state.chatsList = action.payload;
        },
        setContacts(state, action) {
            state.contacts = action.payload;
        },
        setBlacklist(state, action) {
            state.blackList = action.payload;
        },
        setLoadChat(state, action) {
            state.loadChat = action.payload;
        },
        setEmojiState(state, action) {
            state.emojiIsOpen = action.payload;
        },
        setSelectedEmoji(state, action) {
            state.selectedEmoji = action.payload;
        },
        setSearchMessages(state, action) {
            state.isSearchMessage = action.payload;
        },
        setIsFavorites(state, action) {
            resetChatState(state);
            state.isFavorites = action.payload;
            if (action.payload)
                state.selectedChat = state.currentUser;
            else
                state.selectedChat = null;
            state.menu.bar = false;
            state.menu.cover = false;
        },
        setSelectedChannel(state, action) {
            resetChatState(state);
            state.selectedChat = action.payload;
        },
        updateSelectedChannel(state, action) {
            state.selectedChannel = action.payload;
        },
        setClearGlobalSearchUser(state, action) {
            state.clearGlobalSearchUser = action.payload;
        },
        setOnlineStatusSelectedUser(state, action) {
            state.onlineStatusSelectedUser = action.payload;
        },
        setTempChat(state, action) {
            state.tempChat = action.payload;
        },
        setIsAtBottomScroll(state, action) {
            state.isAtBottomScroll = action.payload;
        },
        setTargetMessages(state, action) {
            state.targetMessages = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(setChat.pending, (state) => {
            //if (state.isFavorites) state.isFavorites = false
            //state.loadChat = true
            //if (state.emojiIsOpen) state.emojiIsOpen = false
        })
            .addCase(setChat.rejected, (state, action) => {
            const id = makeChatId({ currentUser: Object.assign({}, action.payload.currentUser), guestInfo: Object.assign({}, action.payload.guestInfo) });
            state.selectedChat = Object.assign(Object.assign({}, action.payload.guestInfo), { chatID: id });
        })
            .addCase(setChat.fulfilled, (state, action) => {
            resetChatState(state);
            state.selectedChat = action.payload;
        });
    }
});
export const { openMenu, closeMenu, closeBar, addSelectedMessage, deleteSelectedMessage, changeMessage, clearSelectedMessage, isSendMessage, setShowCheckbox, setUser, setUserData, setChatList, setLoadChat, setContacts, setBlacklist, setEmojiState, setSelectedEmoji, setSearchMessages, setReplyToMessage, setIsFavorites, setSelectedChannel, updateSelectedChannel, setClearGlobalSearchUser, setOnlineStatusSelectedUser, setTempChat, setIsAtBottomScroll, setTargetMessages } = appSlice.actions;
export default appSlice.reducer;
